import { apiSliceV2Generated as api } from "../../../../apiSlice";
export const addTagTypes = ["Gateways"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getV2Gateways: build.query<GetV2GatewaysApiResponse, GetV2GatewaysApiArg>(
        {
          query: (queryArg) => ({
            url: `/v2/Gateways`,
            params: {
              AccountIds: queryArg.accountIds,
            },
          }),
          providesTags: ["Gateways"],
        },
      ),
      postV2Gateways: build.mutation<
        PostV2GatewaysApiResponse,
        PostV2GatewaysApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Gateways`,
          method: "POST",
          body: queryArg.createGatewayDto,
        }),
        invalidatesTags: ["Gateways"],
      }),
      getV2GatewaysByGatewayId: build.query<
        GetV2GatewaysByGatewayIdApiResponse,
        GetV2GatewaysByGatewayIdApiArg
      >({
        query: (queryArg) => ({ url: `/v2/Gateways/${queryArg.gatewayId}` }),
        providesTags: ["Gateways"],
      }),
      putV2GatewaysByGatewayId: build.mutation<
        PutV2GatewaysByGatewayIdApiResponse,
        PutV2GatewaysByGatewayIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Gateways/${queryArg.gatewayId}`,
          method: "PUT",
          body: queryArg.updateGatewayDto,
        }),
        invalidatesTags: ["Gateways"],
      }),
      deleteV2GatewaysByGatewayId: build.mutation<
        DeleteV2GatewaysByGatewayIdApiResponse,
        DeleteV2GatewaysByGatewayIdApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Gateways/${queryArg.gatewayId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["Gateways"],
      }),
      getActuatorPlans: build.query<
        GetActuatorPlansApiResponse,
        GetActuatorPlansApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Gateways/${queryArg.gatewayId}/ActuatorPlan`,
          params: {
            channel: queryArg.channel,
            start: queryArg.start,
            end: queryArg.end,
            active: queryArg.active,
          },
        }),
        providesTags: ["Gateways"],
      }),
      postActuatorPlan: build.mutation<
        PostActuatorPlanApiResponse,
        PostActuatorPlanApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Gateways/${queryArg.gatewayId}/ActuatorPlan`,
          method: "POST",
          body: queryArg.postActuatorPlanDto,
        }),
        invalidatesTags: ["Gateways"],
      }),
      getAllActuatorPlans: build.query<
        GetAllActuatorPlansApiResponse,
        GetAllActuatorPlansApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/Gateways/ActuatorPlan`,
          params: {
            AccountIds: queryArg.accountIds,
            start: queryArg.start,
            end: queryArg.end,
            active: queryArg.active,
          },
        }),
        providesTags: ["Gateways"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as recalcV2OpenApi };
export type GetV2GatewaysApiResponse =
  /** status 200 Returns the Gateways */ ReadGatewayDto[];
export type GetV2GatewaysApiArg = {
  accountIds?: number[];
};
export type PostV2GatewaysApiResponse = unknown;
export type PostV2GatewaysApiArg = {
  /** The entity to create */
  createGatewayDto: CreateGatewayDto;
};
export type GetV2GatewaysByGatewayIdApiResponse =
  /** status 200 Returns the Gateway */ ReadGatewayDto;
export type GetV2GatewaysByGatewayIdApiArg = {
  gatewayId: number;
};
export type PutV2GatewaysByGatewayIdApiResponse = unknown;
export type PutV2GatewaysByGatewayIdApiArg = {
  /** The id of the Gateway to update */
  gatewayId: number;
  /** The updated Gateway */
  updateGatewayDto: UpdateGatewayDto;
};
export type DeleteV2GatewaysByGatewayIdApiResponse = unknown;
export type DeleteV2GatewaysByGatewayIdApiArg = {
  /** The id of the Gateway to delete */
  gatewayId: number;
};
export type GetActuatorPlansApiResponse =
  /** status 200 OK */ GetActuatorPlanDto[];
export type GetActuatorPlansApiArg = {
  gatewayId: number;
  channel?: string;
  start?: string;
  end?: string;
  active?: boolean;
};
export type PostActuatorPlanApiResponse =
  /** status 201 Created */ GetActuatorPlanDto;
export type PostActuatorPlanApiArg = {
  gatewayId: number;
  postActuatorPlanDto: PostActuatorPlanDto;
};
export type GetAllActuatorPlansApiResponse =
  /** status 200 OK */ GetActuatorPlanDto[];
export type GetAllActuatorPlansApiArg = {
  accountIds?: number[];
  start?: string;
  end?: string;
  active?: boolean;
};
export type GatewayMode = "Repeater" | "Gateway";
export type ReadGatewayDto = {
  gatewayId?: number;
  accountId?: number;
  name?: string | null;
  registrationDate?: string | null;
  lastActivity?: string | null;
  variant?: GatewayMode;
  online?: boolean | null;
  imageHash?: number | null;
  latitude?: number | null;
  longitude?: number | null;
  locationAccuracy?: number | null;
  description?: string | null;
  reportedApplicationFirmware?: string | null;
  currentApplicationFirmware?: string | null;
  currentCommonFirmware?: string | null;
  gatewayVersion?: string | null;
  hwRevision?: string | null;
  swRevision?: string | null;
  optoEye?: boolean;
  modem?: boolean;
  pct?: boolean;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export type CreateGatewayDto = {
  gatewayId: number;
  name: string;
  accountId: number;
  latitude?: number | null;
  longitude?: number | null;
  locationAccuracy?: number | null;
  description?: string | null;
};
export type UpdateGatewayDto = {
  name?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  locationAccuracy?: number | null;
  description?: string | null;
};
export type ActuatorSetPointDto = {
  timestamp?: string;
  value?: string | null;
};
export type GetActuatorPlanDto = {
  gatewayId?: number;
  channel?: string | null;
  schedule?: ActuatorSetPointDto[] | null;
  created?: string;
  active?: boolean;
};
export type PostActuatorPlanDto = {
  channel?: string | null;
  schedule?: ActuatorSetPointDto[] | null;
};
export const {
  useGetV2GatewaysQuery,
  usePostV2GatewaysMutation,
  useGetV2GatewaysByGatewayIdQuery,
  usePutV2GatewaysByGatewayIdMutation,
  useDeleteV2GatewaysByGatewayIdMutation,
  useGetActuatorPlansQuery,
  usePostActuatorPlanMutation,
  useGetAllActuatorPlansQuery,
} = injectedRtkApi;
